import * as React from 'react';
import Box from '@mui/material/Box';
import { Button, Typography } from '@mui/material';
import SaveRoundedIcon from '@mui/icons-material/SaveRounded';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function RemovePresetDialog({ deletePreset, presetDialog, setpresetDialog, userDeletedPreset, presetName, presetCode }) {
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  // const [screenerName, setScreenerName] = React.useState(presetName);
  // const [labelText, setLabelText] = React.useState('Screener Name');

  // const handleDialogOpen = () => {
  //   setOpen(true);
  // };

  const handleDialogClose = () => {
    setOpen(false);
    setpresetDialog(false)
  };

  // const handleInputChange = (event) => {
  //   const input = event.target.value;
  //   const regex = /^[a-zA-Z0-9]*$/; // Regex to allow only letters and numbers
  //   if (input.length > 0 && input[0] === ' ') { // Check if first character is a space
  //     setLabelText('Space cannot be the first character');
  //   } else if (regex.test(input)) {
  //     setScreenerName(input);
  //     setLabelText('Screener Name');
  //   } else {
  //     setLabelText('Spaces and special characters are not allowed');
  //   }
  // };

  React.useEffect(() => {
    // setOpen(presetDialog);
    setLoading(false)
  }, [userDeletedPreset, presetDialog])

  return (
    <>
      {/* <Button onClick={handleDialogOpen} startIcon={<SaveRoundedIcon />} size="small" sx={{ color: 'primary.main', fontSize: '.875rem', textTransform: 'none', px: 1 }}>Save Screener</Button> */}
      <Dialog open={presetDialog} onClose={handleDialogClose}>
        {/* <DialogTitle>This action cannot be undone</DialogTitle> */}
        <DialogContent>
          <DialogContentText sx={{ color: 'primary.main' }}>
            Confirmation required: Delete Screen<br /><br />
            <Typography variant="body2" sx={{ color: '#555' }}>Are you absolutely certain you wish to delete this screen – <b>{presetName}</b>?<br /> Once you confirm, the action cannot be undone and the preset will be permanently removed.</Typography>
          </DialogContentText>
          {/* <Box
            component="form"
            noValidate
            autoComplete="off"
          >
            <TextField
              size="small"
              autoFocus
              margin="dense"
              id="name"
              helperText=""
              label={labelText}
              disabled={loading}
              type="email"
              fullWidth
              variant="standard"
              value={screenerName}
              onChange={handleInputChange}
              inputProps={{ maxLength: 30 }} // Limit the input to 30 characters
            />
          </Box> */}
        </DialogContent>
        <DialogActions>
          <Button size="small" disabled={loading} sx={{ textTransform: 'none' }} onClick={handleDialogClose}>Cancel</Button>
          <Button size="small" disabled={presetName === "" || loading} variant="contained" sx={{ textTransform: 'none' }} onClick={() => { setLoading(true); deletePreset(presetCode); handleDialogClose() }}>{loading ? `Loading...` : `Delete my preset`}</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
